import { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { getCustomerList, getCustomer } from '../services/customer.service';
import { errorHandler } from "../error";
import BaseSelectSearch from "./BaseSelectSearch";

export default function CustomerControl({ allowEmpty = false, readOnly = false, onChange, value }) {
    const { instance } = useMsal();
    const [val, setVal] = useState(null);
    const [disabled, setDisabled] = useState(readOnly);

    useEffect(() => {
        async function fetchData() {
            try {
                let result;
                if (value) {
                    result = await getCustomer(instance, value);
                } else {
                    setVal(null);
                }

                if (result) {
                    if (onChange) {
                        onChange(result.id);
                    }

                    if (!val) {
                        setVal({
                            value: result.id,
                            label: result.name,
                        });
                    }
                }
            } catch (error) {
                errorHandler(error);
            }
        }
        fetchData();
    }, [value])

    return (
        <BaseSelectSearch
            disabled={disabled}
            promise={getCustomerList}
            valueField="id"
            labelField="name"
            value={val}
            filter={{ orderBy: [{ field: "name" }] }}
            placeholder="Välj kund..."
            className="form-control p-0"
            onChange={(e) => {
                setVal(e)
                if (onChange) {
                    onChange(e.value);
                }
            }}
            emptyOption={allowEmpty}
            includeInput
            dark
        />
    )
}